import React, { useState } from 'react';
import { Modal, message } from 'antd';
import { Translate, useTranslate } from '@above-the-treeline/localization';
import { useUser } from '../../../../User/containers/UserDataStore';
import {
	getInitialFormValuesById,
	getRowOptionsList,
} from './AccountInfoModalInitializer';
import { getRowByType } from '../../Form/Form';
import { FormId } from '../../Form/FormId';

interface IAccountInfoModalProps {
	isVisible: boolean;
	setIsVisible: (boolean) => void;
}

function AccountInfoModal({
	isVisible,
	setIsVisible,
}: IAccountInfoModalProps): JSX.Element {
	const { translate } = useTranslate();
	const userDataStore = useUser();
	const { organization: org, accountInfoForm } = userDataStore.state.user;

	const rowOptionsList = getRowOptionsList(accountInfoForm);
	const initialFormValuesById = getInitialFormValuesById(
		org,
		accountInfoForm,
	);

	const [formValuesById, setFormValuesById] = useState(initialFormValuesById);

	const handleSave = async () => {
		if (!formValuesById['country']) {
			Modal.warning({
				title: translate('please_select_a_country'),
			});
		} else {
			setIsVisible(false);
			const didSucceed = await userDataStore.saveOrganization(
				formValuesById,
			);
			return didSucceed
				? message.success(translate('account_information_saved'))
				: message.error(translate('error_saving_account_information'));
		}
	};

	const handleCancel = () => setIsVisible(false);

	const getAccountInfoModalRowByType = (rowOptions: {}, i: number) => (
		<React.Fragment key={i}>
			{getRowByType(
				rowOptions,
				formValuesById,
				setFormValuesById,
				FormId.AccountInfo,
				accountInfoForm,
			)}
		</React.Fragment>
	);

	return (
		<Modal
			visible={isVisible}
			title={
				<b>
					<Translate id="edit_account_info" />
				</b>
			}
			onOk={handleSave}
			onCancel={handleCancel}
			okText={<Translate id="save" />}
			destroyOnClose={true}>
			<div className="account-info-modal-contents">
				{rowOptionsList.map(getAccountInfoModalRowByType)}
			</div>
		</Modal>
	);
}

export default AccountInfoModal;
